import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconXCircleComponent } from "./med-icon-x-circle.component";

@NgModule({
  declarations: [
    MedIconXCircleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconXCircleComponent,
  ],
})
export class MedIconXCircleModule { }
